// extracted by mini-css-extract-plugin
export default {"terms-card":"styles__terms-card--CXHw4","terms":"styles__terms--FLG4s","divider":"styles__divider--k338y"};